module.exports = __webpack_public_path__ + "img/digital-membership-pass.3625ad20.png";